import React from 'react';

/**
 * 圆圈播放图标 - 用于视频列表项
 * 带圆形边框的播放图标
 */
const CirclePlayIcon = ({ 
    width = '200', 
    height = '200', 
    color = '#3B70FF',
    className = '',
    style = {}
}) => {
    return (
        <svg 
            t="1763543334438" 
            className={className}
            style={{ width, height, display: 'block', ...style }}
            viewBox="170.667 170.667 682.666 682.666" 
            version="1.1" 
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path 
                d="M512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m128-256l-213.333333 128V384l213.333333 128z" 
                fill={color}
            />
        </svg>
    );
};

export default CirclePlayIcon;

